"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("react"),t=e.createContext({activeNode:null,setActiveNode:()=>{}});exports.ExpandableGroupContext=t;
